import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom'
import { useTable, usePagination,useSortBy,useRowSelect } from 'react-table'
import { Table, Row, Col, Input } from 'reactstrap'

const ReactTable = ({
  columns, data, getmore
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    rows,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    selectedFlatRows,
    state: { pageIndex, pageSize,selectedRowPaths },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 2 },
      debug: true,
    },
    useSortBy,
    useRowSelect,
    usePagination
  )
  React.useEffect(() => {
    getmore({ pageIndex, pageSize })
  }, [getmore, pageIndex, pageSize])
  return (
    <div className="dataTables_wrapper dt-bootstrap4">
      <Row>
        <Col sm={12} md={6}>
          <div className="dataTables_length">
            <label>
              Hiển thị
              <Input type="select"
                value={pageSize}
                onChange={e => {
                  setPageSize(Number(e.target.value))
                }}
              >
                {[10, 20, 30, 40, 50,100].map(pageSize => (
                  <option key={pageSize} value={pageSize}>
                    {pageSize}
                  </option>
                ))}
              </Input>
              dòng
            </label>
          </div>
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <Table className="table dataTable" {...getTableProps()}>
            <thead>
              {headerGroups.map(headerGroup => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map(column => (
                    <th 
                      className={column.isSorted ? column.isSortedDesc ? "sorting_desc" : "sorting_asc" : " sorting"} 
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                      {column.render('Header')}
                    </th>
                  ))}
                  <th>Actions</th>
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row, i) => {
                prepareRow(row)
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map(cell => {
                      return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                    })}
                    {console.log(row.cells[1].value)}
                    <td>
                      <Link to={`/diemdanh/${row.cells[1].value}`}>
                        <i className="anticon anticon-qrcode"></i>
                      </Link>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </Table>
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={5}>
          <div className="dataTables_info"> Tổng cộng {rows.length} dòng </div>
        </Col>
        <Col sm={12} md={7}>
          <div className="dataTables_paginate paging_simple_numbers">
            <ul className="pagination">
              <li className={canPreviousPage ? "paginate_button page-item previous" : "paginate_button page-item previous disabled"} id="data-table_previous">
                <a href="#" onClick={()=> previousPage()} class="page-link">Previous</a>
              </li>
              <li className="paginate_button page-item active">
                <span className="page-link">{pageIndex + 1}</span>
              </li>
              <li className={canNextPage ? "paginate_button page-item next" : "paginate_button page-item next disabled" } id="data-table_previous">
                <a href="#" onClick={()=> nextPage()} class="page-link">Next</a>
              </li>
            </ul>
          </div>

        </Col>
      </Row>
    </div>
  );
};

ReactTable.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array,
  getmore:PropTypes.func
};

export default ReactTable;



// WEBPACK FOOTER //
// ./src/components/common/ReactTabe.js